import CartManager from './CartManager'

export default CartManager
